export default __webpack_public_path__ + "static/media/pic4.364e67bb.jpg";